import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const notify = (content, success) => {
  return new Promise((resolve) => {

    if (success === true) {
      toast.success(content, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        theme: "light",
        style: {
          backgroundColor: '#7ef78a',
          color: '#000',
          fontSize: '16px',
          border: '2px solid #1dc32d',
        },
      });

    } else if (success === false) {
      toast.error(content, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        theme: "light",
        style: {
          backgroundColor: '#faaa9c',
          color: '#000',
          fontSize: '16px',
          border: '2px solid #f40c1f',
        },
      });

    } else {
      // ⚠️ WARNING when success is not passed
      toast.warning(content, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        theme: "light",
        style: {
          backgroundColor: '#fff3cd',
          color: '#000',
          fontSize: '16px',
          border: '2px solid #ffcc00',
        },
      });
    }

    setTimeout(() => {
      resolve();
    }, 1500);
  });
};


const CustomToaster = () => (
    <ToastContainer />
)
           


export default CustomToaster